import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import Swiper from 'swiper';
import {EffectCreative} from 'swiper/modules';

gsap.registerPlugin(ScrollTrigger);

/* global mainMap */

function rcHomepageAnimations() {
    document.addEventListener('DOMContentLoaded', function () {
        bannerAnimation();
        circleAnimation();
    });

    let isClicking = false;
    const svg = document.querySelector('.circle-svg svg');
    const svgGroups = svg.querySelectorAll('#items > g');

    window.addEventListener('load', function () {
        if (window.innerHeight < 666) return;

        const triggerElement = document.querySelectorAll('.click-trigger-el');
        const cards = document.querySelectorAll('.circle-content');
        const cardsCount = cards.length;

        triggerElement.forEach(trigger => {
            trigger.style.cursor = "pointer";
        });

        if (cardsCount === 0) return;

        const element = document.querySelector('.pin-spacer');
        const totalHeight = element.getBoundingClientRect().height;

        let step = totalHeight / (cardsCount - 1) / 1.18;

        for (let i = 0; i < cardsCount; i++) {
            const marker = document.createElement('div');
            marker.classList.add('scroll-marker');
            marker.setAttribute('data-index', i);
            marker.style.position = 'absolute';

            let topValue = step * i;

            if (i === 0) {
                topValue += 200;
            }

            marker.style.top = `${topValue}px`;

            marker.style.width = '100%';
            marker.style.visibility = 'hidden';
            marker.style.opacity = '0';

            element.appendChild(marker);
        }

        document.addEventListener('click', function (event) {
            const trigger = event.target.closest('.click-trigger-el');

            if (trigger) {
                const targetId = trigger.getAttribute('data-index');
                const targetMarker = document.querySelector(`.scroll-marker[data-index="${targetId}"]`);

                if (targetMarker) {
                    isClicking = true;
                    targetMarker.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                        inline: 'nearest'
                    });

                    svgGroups.forEach((group, index) => {
                        group.classList.remove('active-remove-js');
                        if (index != targetId) {
                            group.classList.add('active-remove-js');
                        }
                    });

                    setTimeout(() => {
                        isClicking = false;
                    }, 1000);
                }
            }
        });

        window.addEventListener('scroll', () => {
            if (!isClicking) {
                svgGroups.forEach(group => {
                    group.classList.remove('active-remove-js');
                });
            }
        });
    });

    function circleAnimation() {
        const animationContainer = document.getElementById('animation-container');
        const cards = document.querySelectorAll('.circle-content');

        if (!animationContainer || !cards || !cards.length || !svg) return;

        const fillCurrentColor = svg.querySelector('.fill-current-color');
        const colorsMap = Object.entries(mainMap);
        const inner = svg.querySelector('#inner');
        inner.querySelector('#animation-text').remove();

        const textMarkup = `
        <text id="animation-text" x="50%" y="54%" text-anchor="middle" font-family="Montserrat" font-weight="700" font-size="40" fill="#FFFFFF">
            ASSESSED
        </text>
        `;

        inner.insertAdjacentHTML('beforeend', textMarkup);

        const animationText = svg.querySelector('#animation-text');

        // Use GSAP's matchMedia for responsive animations
        const mm = gsap.matchMedia();

        mm.add('(min-height: 666px)', () => {
            // Initialize GSAP animations for larger screens
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: '#animation-container',
                    pin: true,
                    scrub: true,
                    start: 'center-=60 center',
                    end: () => `+=${window.innerHeight * (cards.length - 1)}`,
                    markers: false, // remove in production
                },
            });

            function updateCircle(index) {
                if (index < 0) index = 0;
                const color = colorsMap[index][1];
                const label = colorsMap[index][0];

                animationText.textContent = label.toUpperCase();
                gsap.to(fillCurrentColor, {fill: color, duration: 0.5});
            }

            function toggleSvg(index, active = true) {
                if (index < 0) return;
                const group = svgGroups[index];
                const color = colorsMap[index][1];

                const strokeWhite = group.querySelectorAll('.stroke-white');
                const fillWhite = group.querySelectorAll('.fill-white');
                const strokeColor = group.querySelectorAll('.stroke-color');
                const fillColor = group.querySelectorAll('.fill-color');

                if (active) {
                    group.classList.add('active-js');
                    gsap.to(fillColor, {duration: 0.5,});

                    strokeWhite.forEach((el) => gsap.to(el, {stroke: '#ffffff', duration: 0.5}));
                    fillWhite.forEach((el) => gsap.to(el, {fill: '#ffffff', duration: 0.5}));
                    strokeColor.forEach((el) => gsap.to(el, {stroke: color, duration: 0.5}));
                    fillColor.forEach((el) => gsap.to(el, {fill: color, duration: 0.5}));
                } else {
                    group.classList.remove('active-js');
                    gsap.to(fillColor, {duration: 0.2,});

                    strokeWhite.forEach((el) => gsap.to(el, {stroke: color, duration: 0.5}));
                    fillWhite.forEach((el) => gsap.to(el, {fill: color, duration: 0.5}));
                    strokeColor.forEach((el) => gsap.to(el, {stroke: '#ffffff', duration: 0.5}));
                    fillColor.forEach((el) => gsap.to(el, {fill: '#ffffff', duration: 0.5}));
                }
            }

            cards.forEach((card, i) => {
                if (i > 0) {
                    tl.to(cards[i - 1], {
                        opacity: 0,
                        visibility: 'hidden',
                        duration: 0.2,
                        ease: 'power2.out',
                        onComplete: () => {
                            toggleSvg(i - 1, false);
                        },
                    });
                }

                tl.fromTo(card, {
                        opacity: 0,
                        visibility: 'hidden',
                        transformOrigin: 'center center',
                    },
                    {
                        opacity: 1,
                        visibility: 'visible',
                        duration: 5,
                        ease: 'power2.out',
                        transformOrigin: 'center center',
                        onStart: () => {
                            toggleSvg(i);
                            updateCircle(i);
                        },
                        onReverseComplete: () => {
                            toggleSvg(i, false);
                            toggleSvg(i - 1);
                            updateCircle(i - 1);
                        },
                    }, '-=0.3');
            });
        });

        mm.add('(max-height: 665px)', () => {
            // Disable GSAP animations on smaller screens
            cards.forEach(card => {
                gsap.set(card, {visibility: 'visible', opacity: 1, position: 'static', 'transform': 'none'}); // Make cards visible immediately
            });
        });
    }

    function bannerAnimation() {
        // Define the radial gradient backgrounds
        const gradients = [
            'radial-gradient(circle, #5243A0 0%, #3A2F74 100%)',
            'radial-gradient(circle, #DC143C 0%, #4E0715 100%)',
            'radial-gradient(circle, #008080 0%, #004A4A 100%)',
        ];
        // Define the base colors
        const baseColors = [
            '#5243A0',
            '#DC143C',
            '#008080',
        ];

        // Main index to keep track of the current color set
        let mainIndex = 0;

        const bgAnimation = document.querySelector('.bg-animation');
        const bannerButtonText = document.querySelector('.text-animation .elementor-button-text');

        // Variables to manage text flip animation
        const flipTexts = document.querySelectorAll('.flip-text');
        const flipTextWrapper = document.querySelector('.flip-text-wrapper');
        let currentIndex = 0;

        // Initialize the first text
        flipTexts[currentIndex].style.opacity = 1;
        flipTexts[currentIndex].style.display = 'block';
        flipTextWrapper.style.width = `${flipTexts[currentIndex].offsetWidth}px`;

        Swiper.use([EffectCreative]);
        // Initialize Swiper
        const bannerSwiper = new Swiper('.banner-swiper', {
            direction: 'vertical',
            loop: true,
            autoHeight: true,
            autoplay: false,
            speed: 700,
            allowTouchMove: false,
            effect: 'creative',
            creativeEffect: {
                prev: {
                    opacity: 0,
                    shadow: false,
                    origin: 'center bottom',
                    translate: ['0%', '180', '0'],
                },
                next: {
                    opacity: 0,
                    origin: 'center bottom',
                    translate: ['0%', '180', '0'],
                },
            },
        });

        // Function to handle background and text color cycling
        function cycleBackgroundAndText() {
            bgAnimation.style.backgroundImage = gradients[mainIndex];
            bannerButtonText.style.color = baseColors[mainIndex];
        }

        // Function to animate the flip text
        function animateFlipTexts() {
            const currentText = flipTexts[currentIndex];
            gsap.to(currentText, {
                rotationX: -90,
                duration: 0.5,
                onComplete: () => {
                    currentText.style.opacity = 0;
                    currentText.style.display = 'none';

                    currentIndex = (currentIndex + 1) % flipTexts.length;
                    const nextText = flipTexts[currentIndex];

                    flipTexts.forEach(text => text.style.display = 'none');
                    nextText.style.opacity = 1;
                    nextText.style.display = 'block';

                    flipTextWrapper.style.width = `${nextText.offsetWidth}px`;

                    gsap.fromTo(nextText, {rotationX: 90, opacity: 0}, {
                        rotationX: 0,
                        opacity: 1,
                        duration: 0.5,
                    });
                },
            });
        }

        function startAnimation() {
            gsap.to('.text-animation h1, h2:has(.flip-text-wrapper), .text-animation .bb-elementor-custom-color', {
                keyframes: [
                    {color: '#FFF', duration: 0},                     // Start at #FFF
                    {color: baseColors[mainIndex], duration: 1},            // Transition to the color at mainIndex
                    {color: '#FFF', duration: 1},                       // Return to #FFF over 2s
                ],
            });
        }

        function triggerFlashAnimation() {
            const flashElement = document.querySelector('.flash');
            const parentWidth = flashElement.parentElement.offsetWidth;
            const flashWidth = flashElement.offsetWidth;

            // Calculate left position to center the element on the x-axis
            const leftPosition = (parentWidth - flashWidth) / 2;
            flashElement.style.left = `${leftPosition}px`;

            // Remove the class to reset the animation (if it's already applied)
            flashElement.classList.remove('flash-animation');

            // Force a reflow to restart the animation
            void flashElement.offsetWidth;

            // Re-add the class to trigger the animation
            flashElement.classList.add('flash-animation');
        }

        let startTime = null;
        let animationDuration = 4000; // 4 seconds per cycle
        let animationFrame;

        // Main animation loop using requestAnimationFrame
        function animate(timestamp) {
            if (!startTime) startTime = timestamp; // Initialize start time
            let progress = timestamp - startTime;

            if (progress >= animationDuration) {
                // Sync the animations
                mainIndex = (mainIndex + 1) % gradients.length;
                cycleBackgroundAndText();
                animateFlipTexts();
                bannerSwiper.slideNext();
                startAnimation();
                triggerFlashAnimation();
                startTime = timestamp; // Reset the start time for the next cycle
                console.log('animations triggered');
            }

            // Continue the loop
            animationFrame = requestAnimationFrame(animate);
        }

        // Start the animation loop initially
        animationFrame = requestAnimationFrame(animate);

        // Handle tab visibility changes
        document.addEventListener('visibilitychange', () => {
            if (document.hidden) {
                // Cancel the animation loop when tab is inactive
                cancelAnimationFrame(animationFrame);
            } else {
                // Restart the animation when tab becomes active again
                startTime = null; // Reset the start time
                animationFrame = requestAnimationFrame(animate); // Restart the loop
                // flashFix();
            }
        });
    }
}

rcHomepageAnimations();